import { UserService } from 'src/app/users/shared/user.service';
import { Component, OnInit, OnChanges, OnDestroy, Input, ViewChild, ElementRef, SimpleChanges } from '@angular/core';
import { ProfileService } from '../../shared/profile.service';
import { ProfileRelationSearch } from '../../shared/profile-relation-search.model';
import { PagedResult } from '../../../shared/model/generic-paged-result.model';
import { PagingControlsComponent } from '../../../shared/widgets/paging-controls/paging-controls.component';
import { ProfileRelateExistingComponent } from '../../profile-relate-existing/profile-relate-existing.component';
import { Router } from '@angular/router';
import { ObservationService } from 'src/app/shared/observation/observation.service';
import { Subscription } from 'rxjs';
import { ProfileNewComponent } from '../../profile-new/profile-new.component';

@Component({
  selector: 'wl-profile-view-primary-relations',
  templateUrl: 'primary-relations.component.html',
  styleUrls: ['primary-relations.component.less'],
    standalone: false
})
export class ProfileViewPrimaryRelationsComponent implements OnInit, OnChanges, OnDestroy {
  private _profileService: ProfileService;
  private _observationService: ObservationService;
  private _profileSubscription: Subscription;
  private _profileRelationSubscription: Subscription;

  public profileRelations: PagedResult<Array<any>>;
  public showPaging: boolean;
  public relatedProfilesAccess = 0;

  @Input() public profileId: number;
  @ViewChild('pagingControls', { static: false }) public pagingControls: PagingControlsComponent;
  @ViewChild(ProfileRelateExistingComponent) private _relateExisting;
  @ViewChild(ProfileNewComponent) private _profileNew: ProfileNewComponent;

  public constructor(
    profileService: ProfileService,
    observationService: ObservationService,
    private ref: ElementRef,
    private router: Router,
    private _userService: UserService
  ) {
    this._profileService = profileService;
    this._observationService = observationService;
    this.showPaging = false;

    this.profileRelations = new PagedResult();

    this._userService.getCurrentUserSecurityElementAccessLevel('ProfileRelated_Profiles_Tab').then((accessLevel: number) => {
      this.relatedProfilesAccess = accessLevel;
    });
  }

  ngOnInit() {
    this._profileSubscription = this._observationService.observeProfiles().subscribe((id) => {
      this.profileUpdated(id);
    });

    this._profileRelationSubscription = this._observationService.observeProfileRelations().subscribe((id) => {
      this.profileUpdated(id);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.profileId) {
      this.loadRelations(1, true);
    }
  }

  ngOnDestroy() {
    if (this._profileSubscription) {
      this._profileSubscription.unsubscribe();
    }
    if (this._profileRelationSubscription) {
      this._profileRelationSubscription.unsubscribe();
    }
  }

  private profileUpdated(id: number) {
    if (id === this.profileId) {
      this.loadRelations(1, true, true);
    }
  }

  public onPagingEvent(page: number) {
    this.loadRelations(page, false);
  }

  private loadRelations(page: number, isInitialLoad: boolean, forceRefresh?: boolean) {
    const search = new ProfileRelationSearch();
    search.PageNumber = page;
    search.ProfileId = this.profileId;
    search.PageSize = 10;

    this._profileService.getProfileViewPrimaryRelations(search, forceRefresh).then((data: PagedResult<Array<any>>) => {
      this.profileRelations = data;
      this.profileRelations.CurrentPageNumber = search.PageNumber;

      this.showPaging = this.profileRelations.TotalPages > 1;

      if (!isInitialLoad) {
        const element = this.ref.nativeElement;
        window.scrollTo(window.scrollX, element.offsetTop + 50);
      }
    });
  }

  public relateExistingProfile() {
    this._relateExisting.open();
  }

  public viewRelatedProfile(id: number) {
    window.scrollTo(0, 0);
    this.router.navigateByUrl(`/profile/${id}`);
  }

  public relateNewProfileClick() {
    this._profileNew.open();
  }
}
